import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { sweetAlert } from 'src/app/utils/swal';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { RouteService } from '../service/route.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-cancel-route-modal',
  templateUrl: './cancel-route-modal.component.html',
  styleUrls: ['./cancel-route-modal.component.css']
})
export class CancelRouteModalComponent implements OnInit, OnDestroy {
  @Input() routeData;
  @Output() cancelRouteData = new EventEmitter<any>();

  componentLoad = false;
  submitted = false;
  cancelForm: FormGroup;

  constructor(
    private routeService: RouteService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.cancelForm = this.fb.group({
      reason: ['', Validators.required]
    });
  }

  get form() {
    return this.cancelForm.controls;
  }

  cancelRoute() {
    this.submitted = true;
    if (this.cancelForm.invalid) {
      return;
    }

    this.componentLoad = true;
    const queryParams = {
      reason: this.cancelForm.value.reason
    };

    this.routeService
      .cancelRoute(this.routeData._id, queryParams)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.cancelRouteData.emit(this.routeData);
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'Ok');
        this.componentLoad = false;
      });
  }

  closeCancelModal() {
    this.cancelRouteData.emit();
  }

  ngOnDestroy(): void {
  }
}
